export const firebaseConfig = {
    apiKey: "AIzaSyATzq1oS3kRR3MkWSs6Jl3IzHA_-JmCCco",
    authDomain: "travel-guru-5cc6c.firebaseapp.com",
    databaseURL: "https://travel-guru-5cc6c.firebaseio.com",
    projectId: "travel-guru-5cc6c",
    storageBucket: "travel-guru-5cc6c.appspot.com",
    messagingSenderId: "810038858026",
    appId: "1:810038858026:web:dafca4851a4856070b8e53"
};